import React from "react";
import { Coins, Zap, Flame, ShieldCheck, Crown } from "lucide-react";
import { fileUrl } from "@/lib/api";

export function Coin({ className = "w-4 h-4" }) {
  return <Coins className={`${className} text-jixxeo-gold`} />;
}

export function XPBar({ progress }) {
  if (!progress) return null;
  const pct = Math.min(100, Math.round((progress.into_level / progress.level_size) * 100));
  return (
    <div className="w-full">
      <div className="flex justify-between text-[11px] text-muted-foreground mb-1">
        <span className="font-bold text-jixxeo-green">LVL {progress.level}</span>
        <span>{progress.into_level}/{progress.level_size} XP</span>
      </div>
      <div className="xp-track h-2.5 rounded-full overflow-hidden">
        <div className="xp-fill h-full rounded-full transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export function Avatar({ user, size = 48, ring = true }) {
  const src = fileUrl(user?.avatar);
  const border = user?.elite ? "border-jixxeo-purple" : user?.level >= 20 ? "border-jixxeo-gold" : user?.level >= 10 ? "border-jixxeo-blue" : "border-white/15";
  return (
    <div className="relative inline-block shrink-0" style={{ width: size, height: size }}>
      {src ? (
        <img src={src} alt="" className={`w-full h-full rounded-full object-cover border-2 ${border}`} />
      ) : (
        <div className={`w-full h-full rounded-full border-2 ${border} bg-gradient-to-br from-jixxeo-green/30 to-jixxeo-blue/30 flex items-center justify-center font-head font-black text-white`} style={{ fontSize: size * 0.4 }}>
          {(user?.name || "?").charAt(0).toUpperCase()}
        </div>
      )}
      {user?.elite && (
        <span className="absolute -bottom-1 -right-1 bg-jixxeo-purple rounded-full p-0.5 border-2 border-background">
          <Crown className="w-3 h-3 text-white" />
        </span>
      )}
      {!user?.elite && user?.verified && (
        <span className="absolute -bottom-1 -right-1 bg-jixxeo-green rounded-full p-0.5 border-2 border-background">
          <ShieldCheck className="w-3 h-3 text-black" />
        </span>
      )}
    </div>
  );
}

export function StatChip({ icon: Icon, value, label, color = "text-white" }) {
  return (
    <div className="glass rounded-2xl p-3 flex flex-col items-start gap-1">
      <Icon className={`w-4 h-4 ${color}`} />
      <span className="font-display text-lg leading-none">{value}</span>
      <span className="text-[10px] uppercase tracking-wider text-muted-foreground">{label}</span>
    </div>
  );
}

export { Zap, Flame };
